import { createContext, useContext } from 'react';

import { TOfferContextData } from '../types/offer-card';

export const OfferContext = createContext<TOfferContextData | null>(null);

export function useOfferContext() {
  return useContext(OfferContext) as TOfferContextData;
}
